import { render, staticRenderFns } from "./receiptStatus.vue?vue&type=template&id=6f05acf1&scoped=true"
import script from "./receiptStatus.vue?vue&type=script&lang=js"
export * from "./receiptStatus.vue?vue&type=script&lang=js"
import style0 from "./receiptStatus.vue?vue&type=style&index=0&id=6f05acf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05acf1",
  null
  
)

export default component.exports